import { IconButton, Switch } from "@chakra-ui/react";
import { useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { openCreateChapterModel } from "../../../modules/admin-modules/models/Actions";
import { deleteTagRequest } from "../../../modules/superadmin-modules/tags/Actions";
import { togglePractice } from "../../../modules/superadmin-modules/tags/Actions";

const TagsTable = ({ setAdd, setSelectedData }) => {
  const { tags, isLoading } = useSelector((state) => state.superadminTags);
  const dispatch = useDispatch();
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });
  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const Data = tags?.map((data) => {
    return {
      ...data,
      // active: (
      //   <Switch
      //     onChange={() => {
      //       let formData = new FormData();
      //       formData.append("active", data?.active == 0 ? 0 : 1);
      //       formData.append("_method", "PUT");
      //       dispatch(
      //         active({
      //           formData: formData,
      //           id: data?.id,
      //         })
      //       );
      //     }}
      //     isChecked={data?.active == 0 ? false : true}
      //   />
      // ),
      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiFileEditLine />}
          onClick={() => {
            setAdd(false);
            dispatch(openCreateChapterModel());
          }}
        />
      ),
      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiDeleteBinLine color="red" />}
          onClick={() => dispatch(deleteTagRequest(data?.id))}
        />
      ),
      practice: (
        <Switch
          isChecked={data?.practice}
          onChange={() => dispatch(togglePractice(data?.id))}
        />
      ),
    };
  });
  const columns = [
    {
      Header: " العلامة",
      accessor: "name",
    },
    // {
    //   Header: " Active",
    //   accessor: "active",
    // },

    {
      Header: "تعديل",
      accessor: "edit",
    },
    {
      Header: "حذف",
      accessor: "delete",
    },
    {
      Header: "practice",
      accessor: "practice",
    },
  ];

  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data}
      path={"openModel"}
      Actions
      Title={``}
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil(tags?.length / 10)}
    />
  );
};

export default TagsTable;
